export default __webpack_public_path__ + "static/haettenschweiler-06af0a3e86d0d3a6de7abc66b102ffd7.ttf";